import { REWARD_POOL_STATUS, RewardPool } from '@shared/api/types/rewardPools';

export const isRewardPoolUpcoming = (rewardPool: RewardPool) => {
  return (
    rewardPool.status === REWARD_POOL_STATUS.PENDING && new Date(rewardPool.start_date) > new Date()
  );
};

export const isRewardPoolActive = (rewardPool: RewardPool) => {
  return (
    (rewardPool.status === REWARD_POOL_STATUS.ACTIVE &&
      new Date(rewardPool.end_date) > new Date()) ||
    (rewardPool.status === REWARD_POOL_STATUS.PENDING &&
      new Date() >= new Date(rewardPool.start_date))
  );
};

export const isRewardPoolCompleted = (rewardPool: RewardPool) => {
  return (
    rewardPool.status === REWARD_POOL_STATUS.COMPLETED ||
    (rewardPool.status === REWARD_POOL_STATUS.ACTIVE && new Date() > new Date(rewardPool.end_date))
  );
};
